import * as yup from "yup";
import { endOfToday, startOfToday } from "date-fns";
import { BodyMetricType } from "../../../enums";
import {
  fieldMustBeANumber,
  requiredField,
} from "../../../infrastructure/helpers/yupHelper";
import { BODY_METRIC_TYPES } from "./bodyMetricTypes";

export const addBodyMetricFormSchema = yup.object({
  type: yup
    .mixed<BodyMetricType>()
    .nullable()
    .required(requiredField("Метрика")),
  value: yup
    .number()
    .typeError(fieldMustBeANumber("Стойност"))
    .required(requiredField("Стойност"))
    .test("in-range", function (value) {
      const config = this.parent.type ? BODY_METRIC_TYPES[this.parent.type as BodyMetricType] : null;
      if (!config || value === undefined) return true;
      return value >= config.min && value <= config.max
        ? true
        : this.createError({
            message: `Стойността трябва да е между ${config.min} и ${config.max} ${config.unit}.`,
          });
    })
    // The metric's own decimals, the ones its value is shown with (82,45 kg would read 82,5).
    .test("type-decimals", function (value) {
      const config = this.parent.type ? BODY_METRIC_TYPES[this.parent.type as BodyMetricType] : null;
      if (!config || value === undefined) return true;
      const factor = 10 ** config.decimals;
      if (Math.abs(value * factor - Math.round(value * factor)) < 1e-6) return true;
      return this.createError({
        message:
          config.decimals === 0
            ? "Стойността трябва да е цяло число."
            : `Стойността може да има най-много ${config.decimals} ${config.decimals === 1 ? "знак" : "знака"} след десетичната запетая.`,
      });
    }),
  measuredOn: yup
    .date()
    .typeError(requiredField("Дата"))
    .required(requiredField("Дата"))
    // Checked on every validation, so a page left open past midnight still allows today.
    .test("not-future", "Датата не може да е в бъдещето.", (date) => !date || date <= endOfToday()),
});

export type IAddBodyMetricFormModel = yup.InferType<typeof addBodyMetricFormSchema>;

export const getAddBodyMetricFormDefaultValues = (
  type: BodyMetricType | null = null,
): IAddBodyMetricFormModel => ({
  type: type as BodyMetricType,
  value: undefined as unknown as number,
  measuredOn: startOfToday(),
});
